import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from './context/ThemeContext.tsx'
import { initAnalyticsDeferred } from './lib/analytics'

// Defer analytics initialization (GA4 + Mixpanel) to reduce blocking time
initAnalyticsDeferred()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
)
